var _excluded = ["address", "features", "onChange"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { BathIcon, BedIcon, KeysOutlineIcon, ParkingIcon, PropertytypeBuildingOutlineIcon, PropertytypeTownhouseOutlineIcon } from '@domain-group/fe-co-icon';
import { Separator } from '@domain-group/fe-co-allhomes-design-system';
import { Address, Modal } from '../../components';
import FeatureStepper from './feature-stepper';
import PropertyTypeButton from './property-type-button';
import * as styles from './update-property-details.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var propertyTypes = [{
  type: 'HOUSE',
  text: 'House',
  icon: KeysOutlineIcon
}, {
  type: 'TOWNHOUSE',
  text: 'Townhouse',
  icon: PropertytypeTownhouseOutlineIcon
}, {
  type: 'UNIT',
  text: 'Unit / Apartment',
  icon: PropertytypeBuildingOutlineIcon
}, {
  type: 'OTHER',
  text: 'Others',
  icon: PropertytypeBuildingOutlineIcon
}];
var UpdatePropertyDetails = _ref => {
  var address = _ref.address,
    features = _ref.features,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? () => {} : _ref$onChange,
    modalProps = _objectWithoutProperties(_ref, _excluded);
  var handleStepperChange = (field, value) => {
    var newFeatures = _objectSpread(_objectSpread({}, features), {}, {
      [field]: value
    });
    onChange(newFeatures);
  };
  var handlePropertyTypeChange = propertyType => {
    onChange(_objectSpread(_objectSpread({}, features), {}, {
      propertyType
    }));
  };
  return ___EmotionJSX(Modal, _extends({}, modalProps, {
    title: "Edit property details",
    buttonText: "Update details"
  }), ___EmotionJSX("p", null, "Update property details for ", ___EmotionJSX(Address, {
    address: address
  })), ___EmotionJSX("div", {
    css: styles.features
  }, ___EmotionJSX("div", {
    css: styles.steppers
  }, ___EmotionJSX(FeatureStepper, {
    onChange: value => handleStepperChange('bedrooms', value),
    name: "Bedrooms",
    icon: BedIcon,
    value: features.bedrooms
  }), ___EmotionJSX(FeatureStepper, {
    onChange: value => handleStepperChange('bathrooms', value),
    name: "Bathrooms",
    icon: BathIcon,
    value: features.bathrooms
  }), ___EmotionJSX(FeatureStepper, {
    onChange: value => handleStepperChange('parking', value),
    name: "Parking",
    icon: ParkingIcon,
    value: features.parking
  })), ___EmotionJSX(Separator, null), ___EmotionJSX("div", {
    css: styles.propertyType
  }, ___EmotionJSX("p", null, "What\u2019s the best way to describe this property?"), ___EmotionJSX("ul", {
    css: styles.propertyTypeList
  }, propertyTypes.map(propertyType => ___EmotionJSX("li", {
    key: propertyType.type
  }, ___EmotionJSX(PropertyTypeButton, _extends({
    onClick: () => handlePropertyTypeChange(propertyType.type),
    selected: features.propertyType === propertyType.type
  }, propertyType))))))));
};
export default UpdatePropertyDetails;